import client from '@/api/client'
import { baseConfig } from '@/api/clientShared'

export async function copyField(field, newName) {
    const { data } = await client.post(
        `/ajax/dataadmin/fields/${field}`,
        { newName },
        {
            ...baseConfig,
            baseURL: '',
        }
    )

    return data
}

export async function updateField(field) {
    const { data } = await client.put(
        `/ajax/dataadmin/fields/${field}`,
        {},
        {
            ...baseConfig,
            baseURL: '',
        }
    )

    return data
}

export async function deleteField(field) {
    const { data } = await client.delete(`/ajax/dataadmin/fields/${field}`, {
        ...baseConfig,
        baseURL: '',
    })

    return data
}

export async function deleteFields(fields) {
    const { data } = await client.post(
        `/ajax/dataadmin/bulk/delete`,
        { fields },
        {
            ...baseConfig,
            baseURL: '',
        }
    )

    return data
}

export async function pollStatus() {
    const { data } = await client.get(`/ajax/dataadmin/status`, {
        ...baseConfig,
        baseURL: '',
    })

    return data
}

export async function modifyResponsesCheckFile(fileName, uploadToken) {
    const { data } = await client.post(`/dataadmin/modify-responses/check`, {
        fileName,
        uploadToken,
    })

    return data
}

export async function modifyResponsesStartProcessing(
    mapping,
    dateFormat,
    filetoken
) {
    const { data } = await client.post(`/dataadmin/modify-responses/process`, {
        mapping,
        dateFormat,
        filetoken,
    })

    return data
}
